export default {
  meta: {
    title: '集客点'
  }
};

